import { useTranslation } from 'react-i18next'

import { FileIcon, XIcon } from '#/shared/ui/icons'

import type { ComposerAttachment } from '../../model/use-composer'

interface AttachmentTileProps {
  attachment: ComposerAttachment
  onRemove: (id: string) => void
}

function AttachmentTile({ attachment, onRemove }: AttachmentTileProps) {
  const { t } = useTranslation()
  return (
    <div className="animate-pop-in relative size-25 shrink-0">
      <div className="size-full overflow-hidden rounded-[10px] border border-gray-200 bg-paper-avatar">
        {attachment.isImage ? (
          <img
            src={attachment.previewUrl}
            alt=""
            className="size-full object-cover"
          />
        ) : (
          <div className="flex size-full items-center justify-center text-warm-500">
            <FileIcon className="size-8" />
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={() => onRemove(attachment.id)}
        aria-label={t('phonePanel.conversation.removeAttachment')}
        className="absolute top-1 left-1 flex size-4 cursor-pointer items-center justify-center rounded-full bg-black/45 text-paper transition hover:bg-black/60"
      >
        <XIcon className="size-2.5" />
      </button>
      {attachment.ext ? (
        <span className="absolute bottom-1.5 left-1.5 rounded border border-gray-200 bg-white px-1 py-0.5 text-xs leading-none text-gray-300 uppercase">
          {attachment.ext}
        </span>
      ) : null}
    </div>
  )
}

interface ComposerAttachmentsProps {
  attachments: ReadonlyArray<ComposerAttachment>
  onRemove: (id: string) => void
}

/** Horizontal strip of staged file previews above the composer input. */
export function ComposerAttachments({
  attachments,
  onRemove,
}: ComposerAttachmentsProps) {
  if (attachments.length === 0) return null
  return (
    <div className="flex flex-wrap gap-2">
      {attachments.map((attachment) => (
        <AttachmentTile
          key={attachment.id}
          attachment={attachment}
          onRemove={onRemove}
        />
      ))}
    </div>
  )
}
